export default {
  title: "Regra tipo 4 - Colaborador que não pode ser alocado em projeto",
  subtitle: "Qual projeto que determinado colaborador não pode ser alocado? O sistema removerá o projeto da lista do colaborador.",
  token: "collab_allocation_not_in_proj",
  orderBy: "value_a",
  convert: {
    param: "value_a",
    method: "collaborator_registration",
  },
  tables: [
    {
      type: "general",
      title: "Regra geral",
      actions: "edit_remove",
      columns: [
        {
          label: "Colaborador",
          key: "value_a",
        },
        {
          label: "Centro de custo",
          key: "value_b",
          placeholder: "Todos",
          value: "*",
        },
        {
          label: "Nome do CC",
          key: "value_b",
          placeholder: "Todos",
          value: "*",
          convert: {
            method: "project_id_to_id_name"
          }
        },
        {
          label: "Justificativa",
          key: "value_c",
        },
      ],
      data: [],
    },
  ],
  drawer: {
    title: {
      insert_label: "Adicionar Regra",
      update_label: "Editar Regra",
    },
    subtitle: "Colaborador que não pode ser alocado em projeto",
    form: [
      {
        label: "Informe o Colaborador:",
        type: "list_collaborator",
        key: "value_a",
        placeholder: "",
        value: "*",
        visible: false,
      },
      {
        label: "Informe o Centro de Custo:",
        type: "list",
        info: "Acrescente * para selecionar todos",
        key: "value_b",
        placeholder: "",
        value: "*",
        visible: false,
      },
      {
        label: "Justificativa:",
        type: "text",
        info: "Campo opcional",
        key: "value_c",
        placeholder: "Digite aqui uma justificativa",
        value: null,
        visible: false,
      },
    ],
  },
};
